import { useMutation, UseMutationOptions } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

const fetchInvalidateUserAccess = async (userId: string) => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v1/users/${userId}/invalidate_access`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
    }
  )
  handleErrors(response)
}

type MutationOptions = UseMutationOptions<void, unknown, string>

const useMutationAdminInvalidateUserAccess = (
  sideEffectsObject: Partial<MutationOptions>
) => {
  return useMutation(
    (userId: string) => {
      return fetchInvalidateUserAccess(userId)
    },
    {
      ...sideEffectsObject,
      onError: (e) => {
        console.error(e)
        alert(
          'Uh oh! There was an error! Check the console. Take a screenshot and send to engineers.'
        )
      },
    }
  )
}

export default useMutationAdminInvalidateUserAccess
